const parseMarkets = (markets) => {
  return markets.nodes.map((market) => ({
      country: market.title,
      slug: market.slug,
      thumbnail: market.marketDetails.thumbnail.node.mediaItemUrl,
      region: market?.regiones?.nodes[0].name,
      nombres: {
        es: market?.marketDetails?.nombres?.es || '',
        en: market?.marketDetails?.nombres?.en || '',
        pt: market?.marketDetails?.nombres?.pt || '',
      },
      showDetailLink: market?.marketDetails?.showDetailLink,
    }));
}

const parsePaymentMethods = (paymentMethods) => {
  return paymentMethods?.nodes.map((method) => ({
    logo: method.paymentMethodDetails.logo.node.mediaItemUrl,
    name: method.name,
  })) || [];
};




export { parseMarkets, parsePaymentMethods }